export const shoulderDatesList = [
  { id: 0, label: '1 days' },
  { id: 1, label: '2 days' },
  { id: 2, label: '3 days' },
  { id: 3, label: '4 days' },
  { id: 4, label: '5 days' },
  { id: 5, label: '6 days' },
  { id: 6, label: '7 days' },
  { id: 7, label: '8 days' },
  { id: 8, label: '9 days' },
  { id: 9, label: '10 days' },
  { id: 10, label: '11 days' },
  { id: 11, label: '12 days' },
  { id: 12, label: '13 days' },
  { id: 13, label: '14 days' },
  { id: 14, label: '15 days' },
];

export const hotelOptionsList = ['Any Hotel', 'Event Hotel', 'Cancel'];

export const airPoliciesList = [
  { id: 0, label: 'Policy Group 1' },
  { id: 1, label: 'Policy Group 2' },
  { id: 2, label: 'Policy Group 3' },
  { id: 3, label: 'Policy Group 4' },
];

export const PurchaseScreenConstants = {
  NULL_UDID: '0',
  REASON_CODE: 'Reason Code',
};
